exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._37JPKGgaaRThiowfyaxS5c{font-size:17px;font-weight:400;color:\"[theme:neutralPrimary, default:#333333]\";cursor:pointer;overflow:hidden;text-overflow:ellipsis}html[dir] ._37JPKGgaaRThiowfyaxS5c{background:transparent;border-width:0}html[dir=ltr] ._37JPKGgaaRThiowfyaxS5c{text-align:left}html[dir=rtl] ._37JPKGgaaRThiowfyaxS5c{text-align:right}", ""]);
// Exports
exports.locals = {
	"groupName": "_37JPKGgaaRThiowfyaxS5c"
};